<div class="isf-list-page h-100" *ngIf="isShowList">
  <ng-container *ngIf="isShowFilters">
    <ng-template #filterTabs>
      <div class="isf-list-filters-tabs">
        <div class="isf-list-filters-tabs-item" (click)="selectTab(enumIsfStatusTab.ALL)">
          <span class="isf-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumIsfStatusTab.ALL }">
            {{ "LABELS.ALL" | translate }}
          </span>
        </div>

        <div class="isf-list-filters-tabs-item" (click)="selectTab(enumIsfStatusTab.DRAFTS)">
          <span class="isf-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumIsfStatusTab.DRAFTS }">
            {{ "LABELS.DRAFTS" | translate }}
          </span>
          <span class="isf-list-filters-tabs-item-count">({{ draftsCount }})</span>
        </div>

        <div class="isf-list-filters-tabs-item" (click)="selectTab(enumIsfStatusTab.CORRECTIONS_REQUIRED)">
          <span
            class="isf-list-filters-tabs-item-link"
            [ngClass]="{ active: currentSelectedTab === enumIsfStatusTab.CORRECTIONS_REQUIRED }"
          >
            {{ "LABELS.CORRECTIONS_REQUIRED" | translate }}
          </span>
          <span class="isf-list-filters-tabs-item-count">({{ correctionsRequiredCount }})</span>
        </div>

        <div class="isf-list-filters-tabs-item" (click)="selectTab(enumIsfStatusTab.APPROVED)">
          <span class="isf-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumIsfStatusTab.APPROVED }">
            {{ "LABELS.APPROVED" | translate }}
          </span>
          <span class="isf-list-filters-tabs-item-count">({{ approvedCount }})</span>
        </div>
      </div>
    </ng-template>

    <ng-template #searchForm let-isMobile>
      <div class="isf-list-filters-search-input">
        <form (ngSubmit)="searchUpdated(searchParameterCtrl.value)">
          <input type="text" [formControl]="searchParameterCtrl" [placeholder]="'LABELS.ISF_SEARCH_PLACEHOLDER' | translate" />

          <button type="button" class="isf-list-filters-search-input-close" *ngIf="!!searchParameterCtrl.value" (click)="resetSearch()">
            <img alt="remove" src="/assets/icons/icon_close_gray.svg" />
          </button>

          <button type="submit" class="isf-list-filters-search-input-submit">
            <img alt="search" [src]="isMobile ? '/assets/icons/icon_search_gray.svg' : '/assets/icons/icon_search.svg'" />
          </button>
        </form>
      </div>
    </ng-template>

    <div class="row d-none d-lg-flex mb-4">
      <div class="col-12">
        <div class="isf-list-filters">
          <ng-container *ngTemplateOutlet="filterTabs"></ng-container>

          <div class="isf-list-filters-search">
            <ng-container *ngTemplateOutlet="searchForm; context: { $implicit: false }"></ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="isf-list-filters-mobile d-lg-none">
      <ng-container *ngTemplateOutlet="filterTabs"></ng-container>
      <ng-container *ngTemplateOutlet="searchForm; context: { $implicit: true }"></ng-container>
    </div>
  </ng-container>

  <div class="isf-list-header mx-3" *ngIf="isShowHeader">
    <span>
      {{ "PAGE.ISF_LIST.HEADER" | translate }}
      <ng-container *ngIf="isfList.total">({{ isfList.items.length + "/" + isfList.total }})</ng-container>
    </span>
    <div class="d-sm-inline d-flex justify-content-end pr-2">
      <button *ngIf="showButtonShowMore" type="button" class="btn btn-link btn-sm ml-2" (click)="onShowMore()">
        {{ "BUTTON.SHOW_MORE" | translate }}
      </button>
      <button type="button" class="btn btn-link btn-sm ml-2" (click)="refreshIsfs()">{{ "BUTTON.REFRESH" | translate }}</button>
    </div>
  </div>

  <ng-container *ngIf="isfList.total; else emptyList">
    <div class="isf-title-row">
      <div class="isf-title-col-display-part">
        <div class="isf-title-col isf-title-col-name">{{ "LABELS.REFERENCE_NUMBERS" | translate }}</div>
        <div class="isf-title-col isf-title-col-cbp">{{ "STATUS.SECOND_TEXT.RECEIVED_BY_CBP" | translate }}</div>
        <div class="isf-title-col isf-title-col-bl">{{ "LABELS.BILL_OF_LADING" | translate }}</div>
        <div class="isf-title-col isf-title-col-status">{{ "LABELS.STATUS" | translate }}</div>
      </div>
      <div class="isf-title-col isf-title-col-actions">{{ "LABELS.ACTIONS" | translate }}</div>
    </div>
    <div
      class="d-none d-xl-block"
      *ngIf="isShowBatchNotificationSuccess || isShowBatchNotificationPartial || isShowBatchNotificationPending"
    >
      <batch-send-success-notification
        header="EXCELLENT"
        [hint]="paymentSuccessCountStr | translate : { count: payedBatchItems.length }"
        *ngIf="isShowBatchNotificationSuccess"
      ></batch-send-success-notification>

      <batch-process-partial-list-notification
        [batchItem]="batchItem"
        [payedBatchItems]="payedBatchItems.length"
        *ngIf="isShowBatchNotificationPartial"
      ></batch-process-partial-list-notification>

      <batch-send-pending-list-notification
        header="EXCELLENT"
        [hint]="paymentPendingCountStr | translate : { count: pendingBatchItems.length }"
        *ngIf="isShowBatchNotificationPending"
      ></batch-send-pending-list-notification>
    </div>
    <div>
      <pagination-scrolling
        [list]="isfList.items"
        [itemTemplate]="isfDetailsTemplate"
        [scrollContentClass]="scrollContentClass"
        (loadNew)="loadNewOnScroll ? loadNextIsfs() : null"
      ></pagination-scrolling>
      <ng-template #isfDetailsTemplate let-isf="item">
        <isf-detail [isf]="isf" (update)="refreshIsfs()" (editInternalNotes)="onEditInternalNotes(isf)"></isf-detail>
      </ng-template>
    </div>
  </ng-container>
  <ng-template #emptyList>
    <div class="empty-isf-list">
      <div>{{ "LABELS.EMPTY_LIST" | translate }}</div>
      <div class="card-action mt-3">
        <a class="btn btn-primary m-0" routerLink="/isf/disclaimer">
          <div class="border-block">
            <span class="icon-ic_plus"></span>
          </div>
          <div class="text-block">{{ "LABELS.CREATE_YOUR_ISF" | translate }}</div>
        </a>
      </div>
    </div>
  </ng-template>
</div>
